import React from 'react'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'

const EPCRCard = (props) => (
  <Stack
    gap={1}
    padding={1}
    component={Paper}
    // border={`solid 2px ${props.borderColor ?? 'green'}`}
  >
    {props.children}
  </Stack>
)

export default EPCRCard
